<template>
    <div v-if="errorMessage" class="bd-callout bd-callout-danger pe-5 position-relative">
      <button type="button" style="top:20px; right: 20px;" @click="$emit('clearError')" class="position-absolute btn-close"></button>
      <div class="pe-5">
        <span v-if="typeof errorMessage === 'string'">{{ errorMessage }}</span>
        <ul v-else-if="Array.isArray(errorMessage)" class="mb-0">
          <li v-for="(error, index) in errorMessage" :key="index">{{ error }}</li>
        </ul>
      </div>
    </div>
</template>

<script>
export default {
    props:{
        errorMessage: {
            type: [String, Array],
            default: null
        }
    }
}
</script>

<style>

</style>